export default __webpack_public_path__ + "static/media/emerald-3.53fd2692.png";